import Image, { ImageProps } from 'next/image';
import MKLogo from '../../../public/mary-kay-logotype-dark.svg';

export type LogotypeProps = Omit<ImageProps, 'src' | 'alt' | 'blurDataURL'> & {
    width?: number | string;
    height?: number | string;
};

export function Logotype(props: LogotypeProps) {
    return (
        <Image
            blurDataURL="/mary-kay-logotype-dark.svg"
            placeholder="blur"
            src={MKLogo}
            alt="Mary Kay Logo"
            width={134}
            height={19}
            {...props}
        />
    );
}
